export const entergyCompanies = ['ENOL','ELL','Entergy Services, LLC']